export default __webpack_public_path__ + "static/media/Service-4.40792a61.jpg";